/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrgGroupCreateDto } from '../models/OrgGroupCreateDto';
import type { OrgGroupDto } from '../models/OrgGroupDto';
import type { OrgGroupsDto } from '../models/OrgGroupsDto';
import type { OrgGroupUpdateDto } from '../models/OrgGroupUpdateDto';
import type { SysOrgGroup } from '../models/SysOrgGroup';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class OrgGroupService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all org groups for this org
     * @param orgGuid
     * @returns OrgGroupsDto OK
     * @throws ApiError
     */
    public getOrgGroupsInfo(
        orgGuid: string,
    ): CancelablePromise<OrgGroupsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/OrgGroup/{orgGuid}/GetOrgGroupsInfo',
            path: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all org group dtos for this org
     * @param orgGuid
     * @returns OrgGroupDto OK
     * @throws ApiError
     */
    public getAllOrgGroupDtos(
        orgGuid: string,
    ): CancelablePromise<Array<OrgGroupDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/OrgGroup/{orgGuid}/GetAllOrgGroupDtos',
            path: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param orgGroupGuid
     * @param orgGuid The guid of the org group.
     * @param requestBody
     * @returns SysOrgGroup OK
     * @throws ApiError
     */
    public updateOrgGroup(
        orgGroupGuid: string,
        orgGuid: string,
        requestBody?: OrgGroupUpdateDto,
    ): CancelablePromise<SysOrgGroup> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/OrgGroup/{orgGuid}/{orgGroupGuid}/UpdateOrgGroup',
            path: {
                'orgGroupGuid': orgGroupGuid,
                'orgGuid': orgGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new org group.
     * @param requestBody The new org.
     * @returns SysOrgGroup OK
     * @throws ApiError
     */
    public createOrgGroup(
        requestBody?: OrgGroupCreateDto,
    ): CancelablePromise<SysOrgGroup> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/OrgGroup/CreateOrgGroup',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Delete an org group by its Guid.
     * @param orgGroupGuid The id of the org group
     * @param orgGuid
     * @returns any OK
     * @throws ApiError
     */
    public deleteOrgGroup(
        orgGroupGuid: string,
        orgGuid?: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/OrgGroup/{orgGroupGuid}/DeleteOrgGroup',
            path: {
                'orgGroupGuid': orgGroupGuid,
            },
            query: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
